import { render, staticRenderFns } from "./FlashcardForm.vue?vue&type=template&id=4790809f&scoped=true&"
import script from "./FlashcardForm.vue?vue&type=script&lang=js&"
export * from "./FlashcardForm.vue?vue&type=script&lang=js&"
import style0 from "./FlashcardForm.vue?vue&type=style&index=0&id=4790809f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4790809f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VCard,VSelect,VSlideYReverseTransition,VSlideYTransition,VTextField,VTextarea})
